export enum DateViewTypeEnum {
    YEAR_MONTH_DAY,
    YEAR_MONTH,
    YEAR,
}

// type BtnColorTypes = { [K in ButtonType]: { type: K, background: string, textColor: string } };